
import './App.css';
import Homepage from './Pages/Homepage';
import AllRoutes from './routes/AllRoutes';

function App() {
  return (
    <div >
      {/* <Homepage/> */}
      <AllRoutes/>
    </div>
  );
}

export default App;
